import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    no: "",
    gutters: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            subheader: "",
            style: 'height: 50vh; overflow: auto',
            lines: "two"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_subheader, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Sélectionnez le tag à conserver pour la fusion ")
                ])),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsToMerge, (tag) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: tag.id,
                  class: "mb-2",
                  onClick: ($event: any) => (_ctx.selectToKeepTag(tag)),
                  density: "compact",
                  rounded: "xl",
                  border: "",
                  lines: "two"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_btn_icon, {
                      color: "primary",
                      icon: 
                                tag.id === _ctx.toKeepTag.id
                                    ? '$radio_button_checked'
                                    : '$radio_button_unchecked'
                            
                    }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}